export default __webpack_public_path__ + "static/media/Tanya.19956e30.png";